module.exports = "<app-loader></app-loader>\n<router-outlet></router-outlet>\n"